import { SVGProps } from "react";

const STIVegetarian = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Vegetarian" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><circle cx={256} cy={256} r={220} stroke="#0f0" fill="#fff" strokeWidth={25} /><path fill="#0f0" d="m140 120h44l72 225 72-225h44l-90 265h-52z" /></svg>;

export { STIVegetarian };